import axios from "axios";
import { store } from "@/store";

export const menuService = {
  getMenus,
  getMyMenus,
  isMatched,
  getPermissionList,
  updatePermissionList,
  getAccessLevel,
  getMenuByLink
};

function getMenus() {
  return axios.get(`${process.env.VUE_APP_API_URL}/menu/all`);
}

function getMyMenus() {
  return axios.get(`${process.env.VUE_APP_API_URL}/menu/myMenu`);
}

function isMatched(source, target){
  // console.log(source);
  // console.log(target);
  if(source == undefined || source == null){
    return false;
  }
  var sourceParts = source.split("/");
  var targetParts = target.split("/");
  // if(sourceParts.length == 2 && targetParts.length == 2 && sourceParts[1] == targetParts[1]){
  //   return true;
  // }
  // if(sourceParts.length == 3 && targetParts.length == 3 && sourceParts[2] == targetParts[2] ){
  //   return true;
  // }
  if(sourceParts.length >= 2 && targetParts.length >= 2 && sourceParts[1] == targetParts[1]){
    return true;
  }
  return false
}

function getPermissionList(roleId) {
  return axios.get(`${process.env.VUE_APP_API_URL}/permission/${roleId}`);
}

function updatePermissionList(permissionList) {
  return axios.put(`${process.env.VUE_APP_API_URL}/permission/`, permissionList);
}

function getAccessLevel(routePath){
  var selectedMenu = null;
  if(store.state.menu.allMenus.length == 0){
    return -1;
  }
  store.state.menu.allMenus.forEach(menuItem => {
    if (isMatched(menuItem.link, routePath)) {
      selectedMenu = menuItem;
    }
  });
  if(selectedMenu){
    return store.state.menu.permission[selectedMenu.menuId];
  }else{
    return 0;
  }
  
}

function getMenuByLink(link) {
  return axios.post(`${process.env.VUE_APP_API_URL}/menu/by-link`, {link:link, name1:'link'});
}
